import React from 'react';

export type AnchoredModalOptions = {
  width: number;
  approxHeight?: number;
  padding?: number;
  gap?: number;
};

export const getAnchoredModalStyle = (
  anchorRect: DOMRect | null | undefined,
  opts: AnchoredModalOptions
): React.CSSProperties | undefined => {
  if (!anchorRect) return undefined;

  const padding = typeof opts.padding === 'number' ? opts.padding : 12;
  const gap = typeof opts.gap === 'number' ? opts.gap : 6;
  const width = opts.width;
  const approxHeight = typeof opts.approxHeight === 'number' ? opts.approxHeight : 230;

  const vw = typeof window !== 'undefined' ? window.innerWidth : 0;
  const vh = typeof window !== 'undefined' ? window.innerHeight : 0;

  const desiredLeft = Math.max(0, anchorRect.left);
  const maxLeft = vw ? Math.max(padding, vw - width - padding) : desiredLeft;
  const left = Math.min(desiredLeft, maxLeft);

  const belowTop = Math.max(0, anchorRect.bottom + gap);
  const belowWouldOverflow = vh ? belowTop + approxHeight > vh - padding : false;
  const top = belowWouldOverflow
    ? Math.max(padding, anchorRect.top - approxHeight - gap)
    : belowTop;

  return {
    top,
    left,
    margin: 0,
    position: 'fixed',
  };
};
